<div class="main-thank-you-page">
  <div class="main-thank-you-page__icon">
    <svg xmlns="http://www.w3.org/2000/svg" width="144" height="144">
      <path
        style="stroke-width: 4"
        id="path2"
        d="m 60.2,103 51.2,-51.200001 -4.8,-4.6 L 60.2,93.800003 36.799999,70.4 l -4.6,4.599999 z M 72,144 Q 57,144 43.899999,138.5 30.799999,133 21,123.2 11.2,113.4 5.5999995,100.2 0,87 0,72 0,57 5.4999997,43.899999 11,30.799999 20.799999,21 30.6,11.2 43.8,5.5999995 57,0 72,0 87,0 100.1,5.5999995 113.2,11.2 123,21 132.8,30.799999 138.4,43.899999 144,57 144,72 q 0,15 -5.6,28.1 -5.6,13.1 -15.4,22.9 -9.8,9.8 -22.9,15.4 Q 87,144 72,144 Z m 0,-72 q 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,0 z m 0,65.8 q 27.6,0 46.7,-19.1 Q 137.8,99.6 137.8,72 137.8,44.4 118.7,25.299999 99.6,6.1999995 72,6.1999995 q -27.6,0 -46.700001,19.0999995 Q 6.1999995,44.399999 6.1999995,72 q 0,27.6 19.0999995,46.7 Q 44.4,137.8 72,137.8 Z" />
    </svg>
  </div>

  <h1 class="thank-you-title">Vielen Dank!</h1>
  <h2 class="thank-you-subtitle">
    {{ message }}
  </h2>
</div>
